<template>
  <div
    v-b-popover.hover.topright="'+ Add Early Leave Hours'"
    class="hover-pointer"
    @click="addEarlyLeaveHours(dataEarlyLeaveHours.item.id)"
  >
    {{ dataEarlyLeaveHours.item.early_leave_hours }}
  </div>
</template>

<script>
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  name: 'AddEarlyLeaveHours',
  props: {
    dataEarlyLeaveHours: {
      type: Object,
      required: false,
      default: null,
    },
    getAllDataPass: {
      type: Function,
      required: true,
    },
  },
  methods: {
    addEarlyLeaveHours(id) {
      this.$swal.fire({
        title: 'Add Early Leave Hours',
        input: 'number',
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Add',
        showLoaderOnConfirm: true,
        preConfirm: async inputValue => {
          try {
            const githubUrl = `/payslip/${id}/early-leave-hours`
            const response = await axios.patch(githubUrl, { early_leave_hours: inputValue })
            // SweetAlert2 expects something returned here
            return response.data || { success: true }
          } catch (error) {
            const payload = decryptData(error.response.data.payload).message
            const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
            const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
            this.$swal.showValidationMessage(
              `${errorMessage}`,
            )
            // Return false to satisfy consistent-return
            return false
          }
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      }).then(result => {
        if (result.isConfirmed) {
          this.$swal.fire({
            title: 'Added successfully',
            icon: 'success',
          })
          this.getAllDataPass()
        }
      })
    },

  },
}
</script>
